import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {ScrollableSelect} from '../scrollable-select/ScrollableSelect';
import {ScanCompare} from './scan-compare/ScanCompare';
import {CompareFilters} from './compare-filters/CompareFilters';
import {ICompareController} from '../../compare.controller';
import './Compare.scss';

export interface CompareProps {
    controller: ICompareController;
}

@observer
export class Compare extends TechseeBaseComponent<CompareProps> {
    renderInternal(): JSX.Element {
        const {controller} = this.props;
        const {state, translate} = controller;

        const filteredData = controller.filteredScanDataToCompare;

        const selectOptions = state.sessionsScanDatesToCompare.map((opt) => ({
            text: opt.sessionTypeLabel ? `${opt.label} (${opt.sessionTypeLabel})` : opt.label,
            value: opt.value
        }));

        const leftValue = state.compareSelectedSessionIds[0] ?? '';
        const rightValue = state.compareSelectedSessionIds[1] ?? '';

        return (
            <div className='compare-container'>
                <CompareFilters
                    scanTypeOptions={controller.compareScanTypeOptions}
                    floorOptions={controller.compareFloorOptions}
                    roomOptions={controller.compareRoomOptions}
                    scanTypeFilter={state.compareScanTypeFilter}
                    floorFilter={state.compareFloorFilter}
                    roomFilter={state.compareRoomFilter}
                    onScanTypeChange={(v) => controller.setCompareScanTypeFilter(v)}
                    onFloorChange={(v) => controller.setCompareFloorFilter(v)}
                    onRoomChange={(v) => controller.setCompareRoomFilter(v)}
                />

                <div className='compare-selectors'>
                    <ScrollableSelect
                        label={translate('REACT.HISTORY_CONSOLE.COMPARE_SESSION')}
                        value={leftValue}
                        options={selectOptions}
                        className='compare-select'
                        onChange={(val) => controller.onOptionChanged(val, 0)}
                        onScrollEnd={controller.loadMoreCompareOptions}
                    />
                    <ScrollableSelect
                        label={translate('REACT.HISTORY_CONSOLE.COMPARE_SESSION')}
                        value={rightValue}
                        options={selectOptions}
                        className='compare-select'
                        onChange={(val) => controller.onOptionChanged(val, 1)}
                        onScrollEnd={controller.loadMoreCompareOptions}
                    />
                </div>

                <ScanCompare
                    scansGroups={[filteredData[0] ?? [], filteredData[1] ?? []]}
                    translate={translate}
                    controller={controller}
                />
            </div>
        );
    }
}
